import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const RFIOutline = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <path
            d="M18.033 4.5c1.09.017 1.967.868 1.967 1.914V14.162c-.015.878-.647 1.613-1.5 1.823v2.736c-.013.432-.38.779-.833.779-.204 0-.401-.072-.554-.203l-3.803-3.252H5.967C4.877 16.028 4 15.178 4 14.13V6.383C4.018 5.34 4.906 4.5 6 4.5zM18 5.462H5.975c-.541.013-.975.436-.975.956v7.733c.014.517.456.932 1 .932h7.827l.09.08h.001l3.582 3.178v-3.258h.525c.541-.013.975-.436.975-.956V6.394c-.014-.517-.456-.932-1-.932zm-2.32 2.646c.418 0 .743.095.974.287.23.192.346.463.346.813 0 .158-.038.309-.113.45-.07.133-.192.28-.364.442l-.03.028-.239.215c-.143.13-.227.282-.254.454l-.004.026-.011.171c-.051.213-.18.32-.385.32-.206 0-.33-.107-.373-.32 0-.262.034-.47.1-.625.064-.147.177-.291.34-.434l.079-.067c.15-.132.253-.24.307-.325.059-.095.088-.195.088-.3 0-.316-.153-.474-.461-.474-.146 0-.263.043-.35.128-.084.08-.13.19-.137.326-.054.213-.2.32-.438.32-.237 0-.378-.098-.422-.294.004-.357.126-.637.366-.838.24-.202.567-.303.98-.303zm-3.463 3.387c.243 0 .44.19.44.424 0 .233-.197.423-.44.423H7.42c-.244 0-.441-.19-.441-.423 0-.234.197-.424.44-.424h4.798zm0-1.693c.243 0 .44.19.44.423 0 .234-.197.423-.44.423H7.42c-.244 0-.441-.19-.441-.423 0-.234.197-.423.44-.423h4.798zm3.45 1.753c.23 0 .416.18.416.401 0 .222-.186.401-.416.401-.23 0-.417-.18-.417-.4 0-.222.187-.402.417-.402zm-3.45-3.447c.243 0 .44.19.44.423 0 .234-.197.424-.44.424H7.42c-.244 0-.441-.19-.441-.424 0-.234.197-.423.44-.423h4.798z"
            transform="translate(-967 -13) translate(952) translate(11 9)"
          />
        </g>
      </g>
    </svg>
  );
};

RFIOutline.defaultProps = {
  width: '48px',
  height: '48px',
  style: {},
};

export default RFIOutline;
